// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604141004/js/" + chunkId + "." + {"44":"6230dca6","225":"b2d6feb2","481":"061caa49","486":"a51b9b0e","770":"225aa36e"}[chunkId] + ".0.2964730271635774.chunk.js";
};